import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-cms-course",
  "use": "icon-cms-course-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-cms-course\"><path d=\"M810.666667 128h-85.333334v277.333333l-128-96-128 96V128H213.333333v768h597.333334V128z m-256 0v106.666667l42.666666-32 42.666667 32V128h-85.333333z m341.333333 853.333333H128V42.666667h768v938.666666z\" p-id=\"12546\" fill=\"#b5c5d2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/cms-course.svg
// module id = VxGn
// module chunks = 59